import { render, staticRenderFns } from "./list.vue?vue&type=template&id=16c12f0a&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/shared-admin-styles.css?vue&type=style&index=0&id=16c12f0a&prod&scoped=true&lang=css&external"
import style1 from "./list.vue?vue&type=style&index=1&id=16c12f0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c12f0a",
  null
  
)

export default component.exports